/** @jsx jsx */
import { jsx } from '@emotion/react';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';

type Props = {
  message: string;
  onClick: (message: string) => void;
};

const QuickCoachMessage = ({ message, onClick }: Props) => {
  return (
    <div>
      <CoachButton variant="secondary" size="medium" fullWidth={false} onClick={() => onClick(message)}>
        {message}
      </CoachButton>
    </div>
  );
};

export default QuickCoachMessage;
